import { inject, Injectable } from '@angular/core';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TableLazyLoadEvent } from 'primeng/table';
import { Observable, of } from 'rxjs';
import { FilterOptionsDto } from '@myarvato/shared/table';

@Injectable({
  providedIn: 'root',
})
export class FilterOptionsService {
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  // fields
  private readonly baseUrl = `${this.environment.url.api}Transport/FilterOptions`;

  public getFilterOptions(filter: TableLazyLoadEvent, field: string): Observable<FilterOptionsDto> {
    if (filter.last === 0) {
      return of({ field: field, filterOptions: [] });
    }

    const requestUrl = `${this.baseUrl}/${field}`;

    return this.httpClient.post<FilterOptionsDto>(requestUrl, filter, this.getRequestOptions());
  }

  private getRequestOptions() {
    const headers = new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-error-message-target-key': 'none',
    });

    return { headers: headers };
  }
}
